import { render } from "./DownloadPopover.vue?vue&type=template&id=75a6672e&scoped=true"
import script from "./DownloadPopover.vue?vue&type=script&lang=js"
export * from "./DownloadPopover.vue?vue&type=script&lang=js"

import "./DownloadPopover.vue?vue&type=style&index=0&id=75a6672e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a6672e"]])

export default __exports__